<template>
    <div id="app">
        <!-- <vue-topprogress ref="topProgress" color="#da1831" :minimum="70" :speed="200" id="topProgress"></vue-topprogress> -->
        <div class="wrapper">
            <div class="wrapper-in">
                <AppHeader v-if="setup != null"></AppHeader>
                <AppMenuDrop v-if="!isMobileChecker"></AppMenuDrop>
                <AppMobileSideBar v-if="isMobileChecker"></AppMobileSideBar>
                <main class="content" id="content-layout">
                    <!-- <transition name="fade" mode="out-in"> -->
                        <router-view :key="$route.fullPath"/>
                    <!-- </transition> -->
                </main>
                <AppFooter></AppFooter>
                <topBtn :class="{fadeIn: fadeInVisible}"></topBtn>
                <formModalContainer></formModalContainer>
                <!-- <transition name="fade" mode="out-in">
                    <div class="body-overlay" id="body-overlay" @click="closeMobileMenu(!openSendwich)" v-cloak v-if="openFormConsult || overlayTrue || openSalesModal" :class="{'openFormConsult': openFormConsult, 'openSalesModal' : openSalesModal}"></div>
                </transition> -->
            </div>
        </div>
    </div>
</template>

<script>
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import AppMenuDrop from '@/components/burger-menu/burger-menu.vue'
    import AppMobileSideBar from '@/components/mobile-sidebar/mobile-sidebar.vue'
    import topBtn from '@/components/partials/topBtn.vue'
    import formModalContainer from '@/components/forms/form-modal-container.vue'
    import {mapGetters} from 'vuex'
    export default {
        components: {
            AppHeader,
            AppFooter,
            AppMenuDrop,
            AppMobileSideBar,
            topBtn,
            formModalContainer,
        },
        data () {
            return {
                routerName: this.$route.name,
                fadeInVisible: false,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            initSupportPage() {
                this.$router.push({name: 'support'});
            },
            closeMobileMenu(data) {
                this.overlayTrue = false;
                this.$store.commit('Open_Sendwich', false);
                this.$store.commit('Open_form_Consult', false);
                this.$store.commit('openSalesModalAction', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
            },
            checkActionsInURL() {
                var action = window.location
                var param = new URL(window.location.href).searchParams.get('urlAction');
                var cockie = this.$cookie.get('summerSalesModal');
                // && cockie == null
                if (param != null && param == 'summer_sales') {
                    this.$store.commit('openSalesModalAction', true);
                    document.getElementsByTagName('body')[0].classList.add('overlay-open-sales-modal');
                } else {
                    this.$store.commit('openSalesModalAction', false);
                    document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
                }
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 840) {
                    this.iSmobile = true
                    this.$store.commit('setMobileCheckerState', true);
                    // this.$store.commit('setOffsetResponse', -60);
                }
            },
            handleScroll () {
                if (window.scrollY >= window.innerHeight + 500) {
                    this.fadeInVisible = true;
                } else {
                    this.fadeInVisible = false;
                }
            },
            handleResize() {
                if (window.innerWidth < 840) {
                    this.iSmobile = true
                    this.$store.commit('setMobileCheckerState', true);
                } else {
                    this.iSmobile = false
                    this.$store.commit('setMobileCheckerState', false);
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
            if (localStorage.getItem('language') === null) {
                localStorage.setItem('language', '');
            }
            this.$store.dispatch('getFullSetUpProject');
            this.$store.dispatch('getFilterCMSparamsData');
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },  
        mounted () {
            // this.$refs.topProgress.start();
            this.isMobileCheck();
            this.checkResize();
        }
    }
</script>